export const TRIAL_DAYS = 3;
export const DONE_FOR_YOU_FEE = 149;
export const OVERAGE_NOTE = "Additional AI minutes are charged separately once the monthly allowance is exceeded.";

export const PLAN_LIST = [
  {
    id: "starter",
    name: "Starter",
    price: 79,
    tagline: "For sole traders & small businesses",
    accent: "emerald",
    minutes: "200 AI minutes / month",
    features: [
      "200 AI minutes",
      "24/7 AI Receptionist",
      "Dashboard",
      "Call summaries",
      "Call transcripts",
      "Basic analytics",
      "Email support",
    ],
  },
  {
    id: "professional",
    name: "Professional",
    price: 149,
    tagline: "For growing businesses",
    accent: "blue",
    popular: true,
    minutes: "500 AI minutes / month",
    features: [
      "500 AI minutes",
      "Appointment booking",
      "Calendar integration",
      "AI lead capture",
      "Multi-language support",
      "Call transfers",
      "Advanced analytics",
      "Priority support",
    ],
  },
  {
    id: "business",
    name: "Business",
    price: 299,
    tagline: "For high-volume & multi-location",
    accent: "slate",
    minutes: "1,500 AI minutes / month",
    features: [
      "1,500 AI minutes",
      "Multiple locations",
      "Multiple AI Receptionists",
      "Team management",
      "Premium support",
      "Future CRM integrations",
      "Future API access",
    ],
  },
];

export const planById = (id) => PLAN_LIST.find((p) => p.id === id);

// ---- Personal Assistant product ----
export const PA_EXTRA_MINUTES = { minutes: 100, price: 15 };

export const PA_PLAN_LIST = [
  {
    id: "pa_essential",
    name: "Personal Assistant",
    price: 49,
    tagline: "Your always-on AI concierge",
    minutes: "100 AI minutes / month",
    features: [
      "100 AI minutes",
      "Dedicated phone number",
      "AI call answering",
      "Calendar & event management",
      "Reminders & notes",
      "AI call summaries",
    ],
  },
  {
    id: "pa_pro",
    name: "Personal Assistant Pro",
    price: 99,
    tagline: "For working creators & professionals",
    popular: true,
    minutes: "300 AI minutes / month",
    features: [
      "300 AI minutes",
      "Everything in Personal Assistant",
      "Booking management",
      "Travel planning",
      "Contact CRM",
      "Priority AI features",
    ],
  },
  {
    id: "pa_elite",
    name: "Personal Assistant Elite",
    price: 199,
    tagline: "For public figures & their teams",
    minutes: "750 AI minutes / month",
    features: [
      "750 AI minutes",
      "Everything in Pro",
      "Multiple calendars",
      "Team / manager access",
      "VIP support",
      "Advanced AI customisation",
    ],
  },
];

export const paPlanById = (id) => PA_PLAN_LIST.find((p) => p.id === id);

